import { FC } from 'react';
import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { CreateOrUpdateTask } from './create-task/create-task';

export const TaskModeRenderer: FC = () => {
  const { taskMode } = useTaskCenterStore(['taskMode']);

  const renderContent = () => {
    switch (taskMode) {
      case 'create':
      case 'edit':
      case 'citation':
        return <CreateOrUpdateTask />;
      default:
        return null;
    }
  };

  return (
    <motion.div
      initial={{ display: 'none' }}
      animate={{ display: taskMode ? 'flex' : 'none' }}
      exit={{ display: 'none' }}
      transition={{ duration: 0 }}
      css={containerStyles}
    >
      {renderContent()}
    </motion.div>
  );
};

const containerStyles = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
